import { render, staticRenderFns } from "./ActBaseTotalShow.vue?vue&type=template&id=2048b4c4&scoped=true&"
import script from "./ActBaseTotalShow.vue?vue&type=script&lang=js&"
export * from "./ActBaseTotalShow.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseTotalShow.vue?vue&type=style&index=0&id=2048b4c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2048b4c4",
  null
  
)

export default component.exports